import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Group } from 'core/models';
import { ConfigurationsService, LocalesService } from 'core/services';
import { Subscription } from 'rxjs';
import { StudentBatch } from '@models/StudentBatch';

@Component({
  selector: 'lms-group-students-import',
  templateUrl: './group-students-import.component.html',
  styleUrls: ['./group-students-import.component.scss']
})
export class GroupStudentsImportComponent implements OnInit, OnDestroy {
  @Input() group: Group;
  @Output() onEnroll = new EventEmitter<any>();

  public infoMessage: string;

  private tooltipMessagesSubscription: Subscription = new Subscription();

  constructor(private configurationsService: ConfigurationsService, private localesService: LocalesService) {}

  ngOnInit(): void {
    const key = 'lms.group-students-import.info';
    this.tooltipMessagesSubscription = this.configurationsService
      .getInfoMessage$(
        'platformMessages',
        'fields.key',
        key,
        'text',
        this.localesService.getBrowserLocale(),
        false,
        true,
        true
      )
      .subscribe((message) => {
        if (message) this.infoMessage = message;
      });
  }

  public enrollImportedStudents(studentsToImport: { data: StudentBatch[]; hasToReEnroll: boolean }) {
    const studentsToEnroll = studentsToImport.data.map((student) => {
      const { tags } = student;
      let tagsObject: any;
      if (tags) {
        tagsObject = tags.slice(0, 5).reduce((tagsObj, tag, index) => {
          tagsObj[`tag${index + 1}`] = tag;
          return tagsObj;
        }, {});
      }
      const studentToEnroll = { ...student, ...tagsObject };
      delete studentToEnroll.tags;
      return studentToEnroll;
    });
    this.onEnroll.emit({ studentsToEnroll, hasToReEnroll: studentsToImport.hasToReEnroll });
  }

  public ngOnDestroy() {
    this.tooltipMessagesSubscription.unsubscribe();
  }
}
